<template>
    <v-row align="center">
        <v-col cols="12" sm="12" md="12">
            <v-card class="elevation-4">
                <v-card-title>
                    <v-toolbar flat>
                        <v-btn small dark color="cyan darken-4" @click="dialog = true">
                            <v-icon left>fas fa-plus-square</v-icon>Nuevo producto
                        </v-btn>
                        <v-divider class="mx-4" inset vertical></v-divider>
                        <v-btn small dark color="cyan darken-4" @click="mostrarInactivos = !mostrarInactivos">
                            <v-icon left>fa-solid fa-computer-mouse</v-icon>
                            {{ mostrarInactivos ? 'Mostrar Productos Activos' : 'Mostrar Productos Inactivos' }}
                        </v-btn>
                        <v-spacer></v-spacer>
                    </v-toolbar>
                    <v-col cols="12" md="6" sm="12" class="d-flex justify-end">
                        <v-text-field v-model="search" append-icon="fas fa-search" label="Buscar producto" single-inline hide-details @keydown.enter="searchProducto"
                        placeholder="Buscar por nombre, clave o descripción">
                        </v-text-field>
                        <v-btn icon class="mt-4 ml-2" @click="reload()" title="Actualizar">
                            <v-icon dense>fas fa-sync</v-icon>
                        </v-btn>
                        <Columns :headers.sync="headers"></Columns>
                    </v-col>
                </v-card-title>
                <v-card-text>
                <v-data-table dense :headers="filteredHeaders" :items="productos" class="elevation-1"
                :loading="loading" :options.sync="options"
                :server-items-length="totalElements" :items-per-page="itemsPerPage"
                :page.sync="page" @page-count="totalPages = $event"
                hide-default-footer>
                                    <template v-slot:[`item.actions`]="{ item }">
                        <v-menu bottom offset-x rounded="lg" transition="slide-y-transition" color="primary">
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn icon v-bind="attrs" v-on="on" color="teal darken-1" class="white--text" small>
                                    <v-icon>fas fa-ellipsis-v</v-icon>
                                </v-btn>
                            </template>
                            <v-list dense>
                                <v-list-item disabled>
                                    <v-list-item-content>
                                        <v-list-item-subtitle>Producto: {{ item.nombre }} - {{ item.descripcion }}</v-list-item-subtitle>
                                    </v-list-item-content>
                                </v-list-item>
                                <v-list-item @click.prevent="show(item)" v-if="!item.eliminado">
                                    <v-list-item-title>
                                        <v-icon small>fas fa-edit</v-icon> Editar producto
                                    </v-list-item-title>
                                </v-list-item>
                                <v-list-item @click.prevent="remove(item)" v-if="!item.eliminado">
                                    <v-list-item-title class="red--text">
                                        <v-icon small class="red--text" color="danger">fas fa-trash-alt</v-icon> Borrar producto
                                    </v-list-item-title>
                                </v-list-item>
                                <v-list-item @click.prevent="restore(item)" v-if="item.eliminado">
                                    <v-list-item-title class="green--text">
                                        <v-icon small class="green--text" color="green">fas fa-undo</v-icon> Restaurar producto
                                    </v-list-item-title>
                                </v-list-item>
                            </v-list>
                        </v-menu>
                    </template>
                    <template v-slot:[`item.imagen`]="{ item }">
                        <v-img :lazy-src="generateUrlImage(item.imagen)"
                        :src="generateUrlImage(item.imagen)"
                        max-width="50" max-height="50"></v-img>
                    </template>
                    <template v-slot:[`item.eliminado`]="{ item }">
                        <v-chip :color="colorStatus(item.eliminado)" label text-color="white" x-small>
                            <v-icon x-small left color="white">fas fa-tag</v-icon>
                            {{ item.eliminado ? 'Inactivo' : 'Activo' }}
                        </v-chip>
                    </template>
                    <template v-slot:[`item.isServicio`]="{ item }">
                        <v-chip color="teal lighten-1" label text-color="white" x-small>
                            <v-icon x-small left color="white">fas fa-tag</v-icon>
                            {{ item.isServicio ? 'Servicio' : 'Producto' }}
                        </v-chip>
                    </template>
                    <template v-slot:[`item.hasProcess`]="{ item }">
                        <v-chip color="purple lighten-1" label text-color="white" x-small v-if="item.hasProcess">
                            <v-icon x-small left color="white">fas fa-tag</v-icon> Proceso
                        </v-chip>
                    </template>
                    <template v-slot:[`item.amountSell`]="{ item }">
                        <v-chip color="teal lighten-2" label text-color="white" x-small>
                            <v-icon x-small left color="white">fas fa-tag</v-icon>
                            {{ item.amountSell == 0 ? 'Precios variables por cliente' : item.amountSell }}
                        </v-chip>
                    </template>
                </v-data-table>
                </v-card-text>
                <v-card-actions>
                    <PaginationNumber :itemsPerPage.sync="itemsPerPage" :pageCount.sync="totalPages"
                    :totalElements.sync="totalElements" :page.sync="page" :initialize.sync="initialize" />
                </v-card-actions>
            </v-card>
        </v-col>
        <NuevoProduct :unidades.sync="unidades" :categories.sync="categories"
        :dialog.sync="dialog" :initialize.sync="initTableProducto"
        :handleModal="handleModal" v-if="dialog"/>
        <EditProduct :unidades.sync="unidades" :categories.sync="categories"
        :producto.sync="infoProducto"  :dialogEdit.sync="dialogEdit" :initialize.sync="initTableProducto" 
        :handleModalEdit="handleModalEdit" v-if="dialogEdit"/>
    </v-row>
</template>
<script>
import ProductoDataService from "@/service/producto/ProductoDataService";
import UnidadSerivce from "@/service/catalogo/tipoUnidad/tipoUnidadService";
import NuevoProduct from "./NuevoProducto.vue";
import EditProduct from "./EditarProducto.vue";
import { pagedTableMixin } from '@/mixins/serverTableMixin';
import Camera from '@/assets/camera.png'
import Columns from "@/components/shared/Columns.vue";
import PaginationNumber from "@/components/shared/PaginationNumber.vue";
import { showErrorAlert, showSuccessAlert } from "@/helpers/swalHelper";
import { extractMessage } from "@/helpers/errorHelper";
export default {
    name: "ListaProducto",
    mixins: [pagedTableMixin],
    components: { NuevoProduct, EditProduct, Columns, PaginationNumber },
    created() {
        this.fetchTableData();
        this.getUnidad();
        this.getCategories();
    },
    data() {
        return {
            unidades: [],
            categories: [],
            productos: [],
            mostrarInactivos: false,

            dialog: false,
            dialogEdit: false,
            infoProducto: [],
            headers: [
                { text: "Acciones", value: "actions", sortable: false, groupable: false, show: true },
                { text: "ID", align: " d-none", sortable: false, value: "id", visible: false, groupable: false, show: false },
                { text: "Clave", value: "clave", sortable: false, groupable: false, show: true },
                { text: "Nombre", value: "nombre", sortable: false, groupable: false, show: true },
                { text: 'Imagen', value: 'imagen', sortable: false, groupable: false, show: true },
                { text: 'Descripción', value: 'descripcion', sortable: false, groupable: false, show: true },
                { text: 'Categoria', value: 'categoryName', sortable: false, groupable: false, show: true },
                { text: 'Unidad', value: 'tipoUnidad.nombre', sortable: false, groupable: false, show: true },
                { text: 'Tipo', value: 'isServicio', sortable: false, groupable: false, show: true },
                { text: 'Proceso', value: 'hasProcess', sortable: false, groupable: false, show: true },
                { text: 'Precio servicio', value: 'amountSell', sortable: false, groupable: false, show: true },
                { text: 'Stock minimo', value: 'minStock', sortable: false, groupable: false, show: false },
                { text: 'Stock maximo', value: 'maxStock', sortable: false, groupable: false, show: false },
                // { text: 'Precio venta', value: 'precioVentaNatural', sortable: false, groupable: false, show: true },
                { text: 'Estatus', value: 'eliminado', sortable: false, groupable: false, show: true },
            ]
        }
    },
    methods: {
        searchProducto() {
            this.doSearch();
        },
        fetchTable(params){
            return ProductoDataService.listTable( params );
        },
        applyRows({ rows, total, totalPages }){
            this.productos = rows;
            this.totalElements = total;
            this.totalPages = totalPages;
        },
        // Callback que reciben los diálogos de alta y edición.
        initTableProducto(){
            this.reload();
        },

        show(item) {
            ProductoDataService.show(item.id).then(res => {
                if (res.status == 200) {
                    this.infoProducto = res.data;
                    this.dialogEdit = true;
                }
            }).catch(err => {
                showErrorAlert({ title: 'Error al obtener los datos', text: extractMessage(err)});
            });
        },
        remove(item) {
            this.$swal.fire({
                title: "Estas seguro de quitar el producto?",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Si, eliminar!"
            }).then(result => {
                if (result.isConfirmed) {
                    ProductoDataService.delete(item.id).then(_ => {
                        this.initTableProducto();
                        showSuccessAlert({ title: 'Producto desactivado', text: 'Producto desactivado exitosamente' });
                    }).catch(error => {
                        showErrorAlert({ title: 'Error al eliminar el producto', text: extractMessage(error)});
                    });
                }
            });
        },
        restore(item) {
            this.$swal.fire({
                title: "Reactivar producto?",
                icon: "question",
                showCancelButton: true,
                cancelButtonColor: "#d33"
            }).then(result => {
                if (result.isConfirmed) {
                    ProductoDataService.restore(item.id).then( _ => {
                        showSuccessAlert({ title: 'Producto reactivado', text: 'Producto reactivado exitosamente' });
                        this.initTableProducto();
                    }).catch( error => {
                        showErrorAlert({ title: 'Error al reactivar el producto', text: extractMessage(error)});
                    });
                }
            }).catch(err => {
                this.$swal.fire({ icon: 'error', title: 'Oops...', text: extractMessage(err), showConfirmButton: false, timer: 2200 })
            });
        },
        colorStatus(status) { return status ? 'red darken-1' : 'teal darken-2'; },
        generateUrlImage( image ){
            return image != null ? `${this.$store.state.auth.rutaFichero}producto/${image}` : Camera;
        },
        handleModal() { this.dialog = !this.dialog; },
        handleModalEdit() { this.dialogEdit = !this.dialogEdit; },
        async getUnidad(){
            this.unidades = await UnidadSerivce.getAllUnidad().then( resp => resp.data );
        },
        async getCategories(){
            this.categories = await ProductoDataService.lstCategory().then( resp => resp.data );
        }
    },

    computed: {
        filteredHeaders() { return this.headers.filter(h => h.show); }
    }
};
</script>